import { MenuItem, ListItemText } from "@mui/material";

interface ActionItem {
  label: string;
  onClick: () => void
}

const AdminCardActionsMap = (props: {actions: ActionItem[]}) => {
  const {actions} = props;

  return actions.map((item: ActionItem) => <MenuItem onClick={item.onClick} key={item.label}>
    <ListItemText>{item.label}</ListItemText>
  </MenuItem>)
}

export default AdminCardActionsMap;